"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Template {
    constructor(template) {
        this.template = template;
    }
    interpolate(map) {
        var _a;
        let result = '';
        let lastPos = 0;
        const matches = this.template.matchAll(Template.pattern);
        for (const match of matches) {
            const { beforeChar, fullPattern, propertyName } = match.groups;
            if (beforeChar == '\\') {
                result += this.template.slice(lastPos, match.index) + fullPattern;
            }
            else {
                result += this.template.slice(lastPos, match.index) + beforeChar + ((_a = map[propertyName]) !== null && _a !== void 0 ? _a : '');
            }
            lastPos = match[0].length + match.index;
        }
        result += this.template.slice(lastPos);
        return result;
    }
    static isTemplate(possibleTemplate) {
        const matches = possibleTemplate.matchAll(Template.pattern);
        for (const match of matches) {
            if (match.groups.beforeChar !== '\\') {
                return true;
            }
        }
        return false;
    }
}
exports.default = Template;
Template.pattern = /(?<beforeChar>^|.|\r|\n)(?<fullPattern>\$\{(?<propertyName>.*?)\})/g;
//# sourceMappingURL=Template.js.map